
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/list",
      function () {
        return require("private-next-pages/team/list.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/list"])
      });
    }
  